import React, { Component } from 'react';
import styled from 'styled-components';
import device from '../../Assets/Responsive/breakpoints';
import creativitybomb from '../../Assets/Gif/creativitybomb.gif';
import projects from '../../Assets/consts';

const Container = styled.div`
  height: 120vh; /* Since pageSplitTime is 1.4 */
  width: 100%;
  /* border: 1px solid blue; */
  position: relative;
  overflow: hidden;
  @media ${device.mobileMaxWidth} {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
`;

const SkillsTitle = styled.div.attrs({
  style: ({ scrollPercent }) => ({
    transform: `translateX(-${scrollPercent * 10}%)`
  })
})`
  transition: transform 0.5s ease-out;
  font-family: 'AvenirHeavy';
  position: absolute;
  color: #eee;
  right: -50%;
  @media ${device.mobileMaxWidth} {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
    transform: none !important;
    left: 0%;
    right: 0%;
    width: 100%;
    text-align: center;
    font-size: 70px;
  }

  @media ${device.laptop} {
    font-size: 180px;
  }
  @media ${device.laptopL} {
    font-size: 200px;
  }
  @media ${device.desktop} {
    font-size: 350px;
  }
`;

const SkillsList = styled.div`
  /* border: 1px solid #EFEFEF; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  font-family: 'AvenirRoman';
  text-align: left;
  margin-left: 15%;
  margin-right: 10%;
  z-index: 1;
  transform: translateY(30%);
  @media ${device.mobileMaxWidth} {
    flex-direction: column-reverse;
    text-align: center;
    font-size: 20px;
    margin-right: 0%;
    margin-left: 0%;
    margin-top: -60px;
  }
  @media ${device.laptop} {
    font-size: 35px;
  }
  @media ${device.laptopL} {
    font-size: 40px;
  }
  @media ${device.desktop} {
    font-size: 70px;
  }
`;
const SkillsContainer = styled.div`
  @media ${device.mobileMaxWidth} {
    margin-bottom: 30px;
  }
`;
const Skill = styled.div`
  position: relative;
`;
const Img = styled.img`
  border-radius: 50%;
  width: 80px;
  height: 80px;
  object-fit: cover;
  object-position: 100% 0;
  position: absolute;
  top: -27px;
  left: 64px;
  @media ${device.mobileMaxWidth} {
    top: -34px;
    left: 58px;
  }
`;
const Img2 = styled.img`
  z-index: -1;
  border-radius: 50%;
  width: 30px;
  height: 80px;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: -44px;
  left: 117px;
`;
class Skills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenHeight: 0,
      scrollHeight: 0,
      scrollPercent: 0
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.setState({
      scrollHeight: Math.round(window.document.documentElement.scrollHeight)
    });
    this.setState({
      screenHeight: Math.round(window.document.documentElement.clientHeight)
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const { body, documentElement } = event.srcElement;
    const sd = Math.max(body.scrollTop, documentElement.scrollTop);
    let sp = (sd / (documentElement.scrollHeight - documentElement.clientHeight)) * 100;
    const minlimit = (documentElement.clientHeight * projects.skillsTitleMinLimit) / documentElement.scrollHeight;
    const maxlimit = (documentElement.clientHeight * 1180) / documentElement.scrollHeight;
    if (sp >= minlimit && sp <= maxlimit + 3) {
      sp -= minlimit;
      this.setState({ scrollPercent: sp });
    }
  }

  render() {
    const { scrollPercent } = this.state;
    return (
      <Container>
        <SkillsTitle scrollPercent={scrollPercent}>ⓈKILLS</SkillsTitle>
        <SkillsList>
          <div>
            Javascript
            <br />
            React
            <br />
            HTML5
            <br />
            CSS3
            <br />
            Node.js
            <br />
            MongoDB
            <br />
            <br />
            User Experience
            <br />
            Responsive Design
            <br />
            Application Architecture
            <br />
          </div>
          <SkillsContainer>
            <Skill>
              Creativity
              <Img src={creativitybomb} alt="creativity" />
            </Skill>
            Communication
            <br />
            Problem Solving
            <br />
            Open-source Lover
            <br />
            Interpersonal Skills
            <br />
            Collaboration
            <br />
            <br />
            Googling
            <br />
            Organization
            <br />
            Attentions to Detail
            <br />
          </SkillsContainer>
        </SkillsList>
      </Container>
    );
  }
}

export default Skills;
